import { z } from 'zod';

// zod ships `sideEffects: false`, so Rollup drops the classic entry's top-level
// `config(en())` locale registration from the production bundle and every
// validation error degrades to the bare "Invalid input" fallback. Re-register
// the locale explicitly so bundled errors keep their full messages.
z.config(z.locales.en());
